export default {
  MNLSName: 1,
  MNLSCode: 2,
  MLNS: 3,
  Hide: 4,
};
